<template>
    <div class="inner-wrapper" v-if="quotationData.quotation">
        <div class="page-title quote-title">
            <div class="float-left">
                <a href="javascript:void(0)" @click="goBack" class="btn custom-btn" ><i class="ri-arrow-left-s-line"></i></a>
            </div>
            <div class="title-right float-right">
                <a href="javascript:void(0)" class="btn custom-btn" data-toggle="modal" data-target="#notesModal"><!--<img :src="asset('images/note-icon.png')" alt="">-->
                    Notes </a>
                <a href="javascript:void(0)" class="btn custom-btn" @click="openPrevVersionMail(false, null, null, null)"><!--<img :src="asset('images/message-icon.png')" alt="">-->
                    Messages</a>
                <div class="btn-group float-right">
                    <button class="btn  dropdown-toggle" type="button" id="dropdownMenuButtonTop" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i class="ri-settings-4-fill align-bottom"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonTop">
                        <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#quotationRemindersModal"><i class="ri-list-check pe-1"></i> Reminders</a>
                        <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#quotationHistoryModal"><i class="ri-history-line pe-1"></i> History</a>
                        <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#quotationVendorMailModal"><i class="ri-mail-line pe-1"></i> Vendor Mails</a>
                        <template v-for="version in quotationData.quote_versions">
                            <template v-if="version.id != quotationData.quotation.id">
                                <button type="button" class="btn btn-demo btn-notes"
                                        @click="openPrevVersionMail(true, version.id, version.customer_id, version.contact_id)">
                                    <span class="fa fa-comments"></span> Previous Mails V- {{version.version}}
                                    .0
                                </button>
                            </template>
                        </template>
                    </div>
                </div>

            </div>
        </div>
        <div class="new-rfq">

            <div class="alert alert-success" role="alert" v-if="successMessage">
                {{ successMessage }}
            </div>
            <div class="alert alert-danger" role="alert" v-if="errorMessage">
                {{ errorMessage }}
            </div>

            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="javascript:void(0)" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                            {{ error }}
                        </p>
                    </li>
                </ul>
            </div>

            <div class="mb-4 row">
                <div class="col-lg-3 col-md-3">
                    <div class="card panel quote-view-box quote-col">
                        <div class="card-header">
                            <div class="d-sm-flex align-items-center">
                                <h5 class="card-title flex-grow-1 mb-0">Quote #{{quotationData.quotation.quotation_number}}</h5>
                                <div class="flex-shrink-0 mt-2 mt-sm-0">
                                <span class="lt-bl-bg new-rfq-btn" :class="quotationData.quotation.status_details.name.toLowerCase().replace('/', '-').replace(/\s+/g, '-')" id="quote_status">{{quotationData.quotation.status_details.name}}</span>

                                </div>
                            </div>
                        </div>
                        <div class="card-body">

                            <div class="quotation-details" v-if="!isEditFirstSection">
                                <div class="d-flex justify-content-between align-items-center">
                                        <div class="fw-bold fs-14"><h5>{{quotationData.quotation.customer_data.company_name}}<template v-if="quotationData.quotation.customer_contact && quotationData.quotation.customer_contact.contact_name != ''">, ({{quotationData.quotation.customer_contact.contact_name}}) </template></h5></div>
                                        <a href="javascript:void(0)" v-on:click="isEditFirstSection=true" class="fs-18 text-success" id="fmdk"><i class="ri-edit-box-line align-middle"></i></a>
                                    </div>
                                <div class="quotation-col" v-if="quotationData.quotation.customer_data">

                                    <p v-if="quotationData.quotation.customer_contact">{{quotationData.quotation.customer_contact.email}}</p>
                                    <p v-if="quotationData.quotation.customer_contact">{{quotationData.quotation.customer_contact.contact_no}}</p>
                                    <p v-if="quotationData.quotation.customer_data">{{quotationData.quotation.customer_data.address}}</p>

                                </div>
                                <blockquote class="blockquote custom-blockquote blockquote-secondary rounded mb-2" v-if="!isEditFirstSection">
                                    <p class="text-dark mb-1">Sales Rep</p>
                                    <footer class="blockquote-footer mt-0 fs-14 fw-medium"> {{quotationData.sale_rep_name}}</footer>
                                </blockquote>
                            </div>

                            <div class="edit-quote" v-if="isEditFirstSection">

                                <div class="form-group">
                                    <label>Quote #</label>
                                    <input type="text" class="form-control" placeholder="Reason"
                                           v-model="customerForm.quote_update_number">
                                </div>
                                <div class="form-group">
                                    <label>Status</label>
                                    <select class="form-control" v-model="customerForm.quote_status_id">
                                        <option value="null">Select Status</option>
                                        <option v-for="item in quotationData.quote_status" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Reason</label>
                                    <input type="text" class="form-control" placeholder="Reason"
                                           v-model="customerForm.reason">
                                </div>



                                <div class="form-group customebtnrow">
                                    <label><span>Customer</span>
                                        <div class="new-customer-sec">
                                            <!--<router-link :to="{name: 'addCustomer'}" class="btn button-light-text pull-right">New Customer</router-link>-->
                                            <a href="javascript:void(0)" data-toggle="modal" data-target="#customerAddModal" class="btn button-light-text pull-right">New Customer</a>
                                        </div>
                                    </label>
                                    <v-select label="text" :filterable="false"
                                              v-model="customerForm.customer"
                                              :options="customers"
                                              @search="onCustomerSearch"
                                              @input="onCustomerSelect"
                                              @selected="onCustomerSelect"
                                              @deselected ="onCustomerDeSelect">
                                        <template slot="no-options">
                                            type to search customers..
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center" v-html="option.html">
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center" v-html="option.text">
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label>Sales REP</label>
                                    <select class="form-control" v-model="customerForm.sale_rep">
                                        <option value="null">Select Sale Rep</option>
                                        <option v-for="item in settings.sale_users" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="quote_icons">
                                    <a href="javascript:void(0);" v-on:click="saveCustomerData" class="btn btn-primary">Save</a>
                                    <a href="javascript:void(0);" v-on:click="isEditFirstSection=false" class="btn btn-danger">Close</a>
                                </div>


                            </div>
                            <blockquote class="blockquote custom-blockquote blockquote-info rounded mb-0 adm">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <p class="text-dark mb-1">Added By</p>
                                        <div class="edit-section" v-if="quotationData.user.user_type == 1 || quotationData.role == 'Admin'">
                                            <a class="fs-17 text-success" id="adm" href="javascript:void(0)" v-on:click="isEditAddedBySection=true"><i class="ri-edit-box-line align-middle"></i></a>
                                        </div>
                                    </div>
                                    <footer class="blockquote-footer mt-0 fs-14 fw-medium">
                                        <span class="quotation-col" v-if="quotationData.quotation.added_data">
                                            {{quotationData.quotation.added_data.name}}
                                            <template v-for="added in quotationData.added_by">
                                                , {{added.name}}
                                            </template>
                                        </span>
                                    </footer>
                                </blockquote>

                                <div class="edit-quote" v-if="isEditAddedBySection">

                                    <div class="form-group">
                                    <label>Added by</label>
                                        <select class="form-control" v-model="adminForm.admin_user" >
                                            <option v-for="item in quotationData.admin_user" :value="item.id">{{item.name}}</option>
                                        </select>
                                    </div>
                                    <div class="mt-2">
                                        <a href="javascript:void(0);" v-on:click="saveAdminData" class="btn btn-primary">Save</a>
                                        <a href="javascript:void(0);" v-on:click="isEditAddedBySection=false" class="btn btn-danger">Close</a>
                                    </div>
                                </div>
                            <div class="row" v-if="quotationData.quotation.reason">
                                <div class="col-md-12">
                                    <div class="qoute-blk">
                                        <label class="light-clr">Reason</label>
                                        <div>{{quotationData.quotation.reason}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="card panel quote-view-box  quote-col mb-3">
                        <div class="card-header">
                            <div class="d-flex align-items-center">
                                <h5 class="card-title flex-grow-1 mb-0">Versions</h5>
                                <div class="flex-shrink-0 dropstart">

                                    <div class="btn-group pull-right">
                                        <button class="btn btn-soft-success btn-sm dropdown-toggle" type="button" id="dropdownMenuButtonCloneQuote"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="ri-more-2-fill align-middle"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonCloneQuote">
                                            <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#CloneModal">Clone Quote</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">

                            <div class="table-responsive product-create table-card">
                                <table class="table table-custom table-bordered mb-0">
                                    <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Version</th>
                                        <th>Created Date</th>
                                        <th style="width: 65px;">Action</th>
                                    </tr>
                                    </thead>
                                    <tr v-for="(version, index) in quotationData.quote_versions">
                                        <td>{{index+1}}</td>
                                        <td>
                                            <a class="link" href="javascript:void(0)" @click="goToVersion(version.id)">V- {{version.version}}.0</a>
                                        </td>
                                        <td>{{formatDate(version.created_at)}}</td>
                                        <td>
                                            <a
                                            :class="[version.final_version ? 'like' : 'final_btn']"
                                            :title="getVersionTitle(version)"
                                            v-on:click="updateVersionModal(version.id)"
                                            ><i class="ri-thumb-up-fill"></i></a>
                                            <a v-if="!version.final_version" href="javascript:void(0);" class="del_btn" title="Delete Quote Version"
                                               v-on:click="deleteVersionModal(version.id)"><i class="fa fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="card panel quote-view-box  quote-col order-col mb-3">
                        <div class="card-header">
                            <div class="d-flex align-items-center">
                                <h5 class="card-title flex-grow-1 mb-0">Sales Order</h5>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive product-create table-card">
                                <table class="table table-custom table-bordered mb-0">
                                    <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Created Date</th>
                                    </tr>
                                    </thead>
                                    <template v-if="salesOrder.orders.data.length">
                                        <tr v-for="(item, index) in salesOrder.orders.data">
                                            <td>
                                                <router-link :to="{ name: 'orderShow', params: { id: item.id }}">#{{ item.order_number }}</router-link>
                                            </td>
                                            <td>{{ formatDate(item.created_at) }}</td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="2" style="text-align:center">No records found!</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="card panel quote-view-box  quote-col order-col mb-3">
                        <div class="card-header">
                            <div class="d-flex align-items-center">
                                <h5 class="card-title flex-grow-1 mb-0">Purchase Order</h5>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive product-create table-card">
                                <table class="table table-custom table-bordered mb-0">
                                    <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Created Date</th>
                                    </tr>
                                    </thead>
                                    <template v-if="purchaseOrder.orders.data.length">
                                        <tr v-for="(item, index) in purchaseOrder.orders.data">
                                            <td>
                                                <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn">#{{ item.po_number }}</router-link>
                                            </td>
                                            <td>{{ formatDate(item.created_at) }}</td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="2" style="text-align:center">No records found!</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-9 col-md-9">

                    <div class="card panel view-quote-box  mb-4">
                        <div class="card-header header-sec">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center header-left">
                                    <h5 class="card-title flex-grow-1 mb-0">Quote Name</h5>
                                    <input class="form-control" type="" name="" v-model="quotationData.quotation.quote_name" v-on:blur="updateQuoteName" placeholder="Enter Quote Name" style="width: 56%; height: 30px;">
                                </div>
                                <div class="flex-shrink-0">
                                    <button type="button" class="btn btn-success btn-sm" data-toggle="modal" data-target="#importModal">
                                        <i class="ri-upload-2-fill align-middle me-1"></i> Import
                                    </button>
                                    <!--<a href="javascript:void(0)" data-toggle="modal" data-target="#exportModal" class="btn btn-primary btn-sm" id="flvw"><i class="ri-eye-line align-middle me-1"></i> Expand</a>-->
                                    <a href="javascript:void(0)" @click="isExpandedView=true" v-if="isExpandedView==false" class="btn btn-primary btn-sm" id="flvw"><i class="ri-eye-line align-middle me-1"></i> Expand</a>
                                    <a href="javascript:void(0)" @click="isExpandedView=false" v-if="isExpandedView==true" class="btn btn-primary btn-sm" id="vwvw"><i class="ri-eye-off-line align-middle me-1"></i> Hide</a>
                                </div>
                            </div>

                        </div>
                        <div class="card-body">
                            <div class="table-responsive product-create table-card">
                                <table class="table table-custom ">
                                    <thead>
                                    <tr>
                                        <th style="width: 130px">Item#</th>
                                        <th style="width: 250px">Name</th>
                                        <th>Description</th>
                                        <th style="width: 105px">Quantity Tier</th>
                                        <th style="width: 80px">SKU</th>
                                        <th style="width: 100px">Unit</th>
                                        <th v-if="isExpandedView==true">Order Number</th>
                                        <th v-if="isExpandedView==true">Status</th>
                                        <th style="width: 80px">
                                        Action
                                            <!--<a href="javascript:void(0)" class="add-btn"
                                               v-if="quotationData.quotation.status == 1 || quotationData.quotation.status == 2"
                                               v-on:click="addProduct">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </a>-->
                                        </th>
                                    </tr>
                                    </thead>
                                    <template v-for="(item, index) in quotationData.quote_products">
                                        <template v-if="item.product_id != null && edit_product_id !== item.product_id">
                                            <tr :key="'view_'+item.product_id" :class="'product_view_'+item.product_id">
                                                <td>
                                                    <template v-if="item.master_product_id">
                                                        <router-link :to="{name: 'productsDetails', params: {id: item.master_product_id}}" target="_blank" title="Details Product">
                                                            {{item.master_product_num}}
                                                        </router-link>
                                                    </template>

                                                </td>
                                                <td :class="'product_name_'+item.product_id">
                                                    <a href="javascript:void(0)">{{item.product_name}}</a>
                                                </td>
                                                <td :class="'product_desc_'+item.product_id">
                                                    <div v-html="item.description"></div>
                                                </td>
                                                <td :class="'product_tiers_'+item.product_id">
                                                    <div class="inrcol" v-for="(tier, tierIndex) in item.quote_tiers">
                                                        {{tier.tier_value}}
                                                    </div>
                                                </td>
                                                <td :class="'product_sku_'+item.product_id">
                                                    <div class="inrcol" v-for="(tier, tierIndex) in item.quote_tiers">
                                                        {{tier.sku}}
                                                    </div>
                                                </td>
                                                <td :class="'product_unit_'+item.product_id">
                                                    {{item.quantity_unit}}
                                                </td>
                                                <td v-if="isExpandedView==true">
                                                    <template v-if="item.orders && item.orders.length > 0">
                                                        <template v-for="(order, orderIndex) in item.orders">
                                                            <router-link :to="{ name: 'orderShow', params: { id: order.id }}" target="_blank">#{{order.order_number}}</router-link> <br />
                                                        </template>
                                                    </template>
                                                </td>
                                                <td v-if="isExpandedView==true"><span class="pending-text">{{item.status}}</span></td>
                                                <td>
                                                    <a href="javascript:void(0)" class="edit-btn me-1" v-on:click="editProduct(item.product_id)" style="font-size: 18px">
                                                        <i class="ri-edit-box-line me-1"></i>
                                                    </a>
                                                    <!--<a href="javascript:void(0)" class="delete-btn text-danger" style="font-size: 18px"
                                                       v-if="(quotationData.quotation.status == 1 || quotationData.quotation.status == 2) && quotationData.count_products > 1 && (item.orders && item.orders.length == 0)"
                                                       v-on:click="removeProduct(index, item)">
                                                        <i class="ri-delete-bin-6-line"></i>
                                                    </a>-->
                                                    <a href="javascript:void(0)" class="delete-btn text-danger" style="font-size: 18px"
                                                       v-if="(quotationData.quotation.status == 1 || quotationData.quotation.status == 2) && quotationData.count_products > 1"
                                                       v-on:click="removeProduct(index, item)">
                                                        <i class="ri-delete-bin-6-line"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr :key="'edit_'+index" :class="'product_edit_'+item.product_id">
                                                <td>
                                                    <div class="form-group custom-dropdown">
                                                        <v-select label="product_num" :filterable="false"  placeholder="#item"
                                                                  v-model="quotationData.quote_products[index].master_product"
                                                                  :options="products"
                                                                  @input="onProductSelect($event, index)"
                                                                  @search="onProductSearch"
                                                                  @selected="onProductSelect($event, index)"
                                                                  @deselected ="onProductDeSelect">
                                                            <template slot="no-options">
                                                                type to search products..
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center" v-html="option.product_name">
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center" v-html="option.product_num">
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                    </div>
                                                    <div class="form-check" v-if="quotationData.quote_products[index].master_product_id">
                                                        <label class="form-check-label">
                                                            <input type="checkbox" v-model="quotationData.quote_products[index].is_master_product_modify" class="form-check-input" value=""> Modify the original product?
                                                        </label>
                                                    </div>
                                                </td>
                                                <td :class="'product_name_'+item.product_id">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Enter Product"
                                                               v-model="quotationData.quote_products[index].product_name">
                                                    </div>
                                                </td>
                                                <td :class="'product_desc_'+item.product_id">
                                                    <div class="form-group">
                                                        <!--<textarea rows="4" class="form-control"
                                                              v-model="quotationData.quote_products[index].description"></textarea>-->
                                                        <!--<ckeditor :id="'edit_description_'+index" :key="'edit_description_'+index"
                                                                  v-model="quotationData.quote_products[index].description"
                                                                  tag-name="textarea"
                                                                  type="inline"
                                                                  :config="editorConfigMin"></ckeditor>-->
                                                        <vue-ckeditor :id="'edit_description_'+index" :key="'edit_description_'+index"
                                                                      v-model="quotationData.quote_products[index].description"
                                                                      tag-name="textarea"
                                                                      types="inline"
                                                                      :config="editorConfigMin"></vue-ckeditor>
                                                    </div>
                                                </td>
                                                <td :class="'product_tiers_'+item.product_id">
                                                    <div class="form-group">
                                                        <template v-for="(tier, tierIndex) in item.quote_tiers">
                                                            <input type="text" class="form-control" placeholder=""
                                                                   @keyup="tierNumberFormat(index, tierIndex)"
                                                                   v-model="quotationData.quote_products[index].quote_tiers[tierIndex].tier_value">
                                                        </template>
                                                    </div>
                                                </td>
                                                <td :class="'product_sku_'+item.product_id">
                                                    <div class="form-group">
                                                        <template v-for="(tier, tierIndex) in item.quote_tiers">
                                                            <div class="sku-group">
                                                                <input type="text" class="form-control" placeholder=""
                                                                    v-model="quotationData.quote_products[index].quote_tiers[tierIndex].sku">

                                                                <template v-if="tierIndex > 2">
                                                                    <a href="javascript:void(0)" v-on:click="removeTier(index, tierIndex, tier, item)" class="remove-icon-btn"><i class="ri-delete-bin-6-line" style="font-size: 18px;"></i></a>
                                                                </template>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </td>
                                                <td :class="'product_unit_'+item.product_id">
                                                    <div class="d-flex">
                                                        <div class="form-group">
                                                            <select class="form-control"
                                                                    v-model="quotationData.quote_products[index].quantity_unit" style="margin-bottom: 0;">
                                                                <option value="bags">Bags</option>
                                                                <option value="impressions">Impressions</option>
                                                                <option value="kg">Kg</option>
                                                                <option value="lb">Lb</option>
                                                                <option value="pcs">Pcs</option>
                                                                <option value="roll">Roll</option>
                                                                <option value="M Bags">M Bags</option>
                                                                <option value="M Impressions">M Impressions</option>
                                                                <option value="pallet">Pallet</option>
                                                                <option value="container">Container</option>
                                                                <option value="ft">Ft</option>
                                                                <option value="cases">Cases</option>
                                                            </select>
                                                        </div>
                                                        <a  href="javascript:void(0)" v-on:click="addNewTier(index)" class="btn btn-primary btn-sm" style="line-height: 15px; padding: 6px 5px;
margin-left: 5px;"><i
                                                        class="ri-add-line" style="font-size: 19px; line-height: 18px;"></i></a>
                                                    </div>
                                                </td>
                                                <!--<td>
                                                    <template v-if="item.orders && item.orders.length > 0">
                                                        <template v-for="(order, orderIndex) in item.orders">
                                                            <router-link :to="{ name: 'orderShow', params: { id: order.id }}" target="_blank">#{{order.order_number}}</router-link> <br />
                                                        </template>
                                                    </template>
                                                </td>
                                                <td><span class="pending-text">{{item.status}}</span></td>-->
                                                <td>

                                                    <a href="javascript:void(0);" v-on:click="saveProduct(item, index)" class="save-btn">
                                                        <i class="fas fa-save pull-right save-icon save_product_btn"></i>
                                                    </a>
                                                    <a href="javascript:void(0);" v-on:click="cancelProductEdit" class="close-btn">
                                                        <i class="fa fa-times pull-right save-icon cancle_product_btn"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </template>

                                    </template>


                                </table>
                            </div>
                            <!--<div class="add-attachment-section">
                                <div class="add-attachment">
                                    <div class="form-group files">
                                        <label>Add Attachment :</label>
                                        <vue-dropzone :options="dropzoneOptions"
                                                    :id="'attachment-dropzone'"
                                                    v-on:vdropzone-sending="sendingEventQuoteAttachments"
                                                    v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                        </vue-dropzone>
                                    </div>
                                </div>
                                <div class="add-file">
                                    <div class="" id="add_quote_files_attached">
                                        <template v-if="quotationData.quote_attachments && quotationData.quote_attachments">
                                            <div v-for="(quote_attachment, index) in quotationData.quote_attachments" :class="'pdf-dwn-sec num_' + quote_attachment.id">
                                                <template v-if="quote_attachment.image_type=='2'">
                                                    <span class="far fa-file-pdf"></span>
                                                </template>
                                                <template v-else>
                                                    <input type="hidden" id="img_attach_id"
                                                        :value="quote_attachment.id">
                                                    <a class="lightbox" :href="'#attach'+quote_attachment.id">
                                                        <img :src="'/quote_files/' + quote_attachment.file_name"
                                                            style="width: 40px;height: 32px;">
                                                    </a>
                                                    <div class="lightbox-target" :id="'attach'+quote_attachment.id"><img
                                                        :src="'/quote_files/'+quote_attachment.file_name"><a
                                                        class="lightbox-close" href="#"></a></div>
                                                </template>
                                                <div class="filename-col">
                                                    <div class="name-input">
                                                        <span class="file-name">{{quote_attachment.file_name}}</span>
                                                        <input type="text" class="form-control" placeholder="">
                                                    </div>
                                                    <small class="light-clr">{{quote_attachment.size}}</small>
                                                </div>

                                                <div class="file-remv-btn">
                                                    <a  href="javascript:void(0)" v-on:click="download('/quote_files/', quote_attachment)"
                                                    class=" download-btn"> <i class="fa fa-download fa-pull-right"></i></a>
                                                    <a class="trash-btn"  href="javascript:void(0)"
                                                    @click="deleteQuoteFile(quote_attachment.file_name, quote_attachment.id, index)">
                                                        <i class="fa fa-trash-alt fa-pull-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>-->


                        </div>
                    </div>

                    <div class="row">
                            <div class="col-lg-6">
                                <div class="card mb-4">
                                    <div class="card-header">
                                        <div class="d-flex align-items-center">
                                            <h5 class="card-title flex-grow-1 mb-0">Add Attachment</h5>
                                        </div>
                                    </div>
                                    <div class="card-body smdrag">
                                        <!--<div class="dropzone">
                                            <div class="fallback">
                                                <input name="file" type="file" multiple="multiple">
                                            </div>
                                            <div class="dz-message needsclick">
                                                <h5 class="mt-1 mb-1">Drop files here or click to upload.</h5>
                                            </div>
                                        </div>-->
                                        <div class="add-attachment">
                                    <div class="form-group files">
                                        <vue-dropzone :options="dropzoneOptions"
                                                    :id="'attachment-dropzone'"
                                                    v-on:vdropzone-sending="sendingEventQuoteAttachments"
                                                    v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)"
                                                     v-on:vdropzone-error="(file, response) => afterUploadFail(file, response)">
                                        </vue-dropzone>
                                    </div>
                                </div>
                                <div class="add-file">
                                    <div class="" id="add_quote_files_attached">


                                        <template v-if="quotationData.quote_attachments && quotationData.quote_attachments">
                                            <div v-for="(quote_attachment, index) in quotationData.quote_attachments" :class="'pdf-dwn-sec num_' + quote_attachment.id">
                                                <div class="d-flex p-2">
                                                    <div class="add-file-left flex-grow-1">
                                                        <div class="d-flex ">
                                                            <template v-if="quote_attachment.image_type=='2'">
                                                                <span class="file-option-icon"><i :class="getFileIconForAttachment(quote_attachment)"></i></span>
                                                                <!--<span class="file-option-icon"><i class="ri-folder-zip-line"></i></span>
                                                                <span class="file-option-icon"><i class="ri-file-ppt-2-line"></i></span>
                                                                <span class="file-option-icon"><i class='bx bxs-file-pdf'></i></span>
                                                                <span class="file-option-icon"><i class='bx bxs-file-doc' ></i></span>
                                                                <span class="file-option-icon"><i class='bx bx-image-alt' ></i></span>
                                                                -->
                                                            </template>
                                                            <template v-else>

                                                                <a class="lightbox" href="javascript:void(0)" @click="imagePreview(quote_attachment.file_url)">
                                                                    <img :src="quote_attachment.file_url"
                                                                        style="width: 40px;height: 32px;">
                                                                </a>

                                                            </template>
                                                            <div class="filename-col">
                                                                <div class="name-input">
                                                                    <span class="file-name" v-if="quote_attachment.id != attachment_edit_id">{{quote_attachment.edited_file_name}}</span>
                                                                    <div class="d-flex editname" v-if="quote_attachment.id == attachment_edit_id">
                                                                        <div>
                                                                            <input type="text" class="form-control" placeholder="" v-model="quotationData.quote_attachments[index].edited_file_name">
                                                                            <a href="javascript:void(0);" @click="renameQuoteFile(quote_attachment.edited_file_name, quote_attachment.id, index)" class="text-primary" style="font-size: 18px"><i class="ri-save-3-fill"></i></a>
                                                                            <a href="javascript:void(0);" @click="attachment_edit_id = null" class="text-danger" style="font-size: 18px"><i class="ri-close-line"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <small class="light-clr">{{quote_attachment.size}}</small>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="file-remv-btn flex-shrink-0 ms-2">
                                                        <div class="d-flex gap-1">
                                                            <!--<a class="trash-btn"  href="javascript:void(0)"
                                                                @click="deleteQuoteFile(quote_attachment.file_name, quote_attachment.id, index)">
                                                                    <i class="fa fa-trash-alt fa-pull-right"></i>
                                                                </a>-->
                                                            <a  href="javascript:void(0)" v-on:click="download('/quote_files/', quote_attachment)"
                                                                class=" download-btn" style="font-size:18px;"> <i class="ri-download-2-line"></i></a>
                                                            <div class="btn-group">
                                                                <button style="font-size:18px;" class="btn btn-icon text-muted btn-sm fs-18 dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <i class="ri-more-fill"></i>
                                                                </button>
                                                                <ul class="dropdown-menu">
                                                                    <li><a class="dropdown-item" href="javascript:void(0);" @click="attachment_edit_id = quote_attachment.id"><i class="ri-pencil-fill align-bottom me-2 text-muted"></i> Rename</a></li>
                                                                    <li><a class="dropdown-item" href="javascript:void(0);" @click="deleteQuoteFile(quote_attachment.file_name, quote_attachment.id, index)"><i class="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>


                                        <!-- end dropzon-preview -->

                                    </div>
                                </div>
                            </div>
                        </div><!--end card-->

                    <div class="btnrow text-right">
                        <button v-if="quotationData.quotation.status == 1 || quotationData.quotation.status == 2" class="btn btn-info me-1 fs-14" @click="addProduct">Add New Product</button>
                        <template v-if="quotationData.quotation.status=='1' && isQuoteReady() == true">
                            <a href="javascript:void(0)" class="btn custom-btn" data-toggle="modal" data-target="#sendToVendorModal">Send to vendor</a>
                            <!--<router-link class="btn custom-btn" :to="{name: 'PriceCalculationPage', params: {id: quotationData.quotation.id}}">Calculation</router-link>-->
                        </template>
                        <template v-if="(quotationData.quotation.status=='2' || quotationData.quotation.status=='3') && isQuoteReady() == true">
                            <router-link class="btn custom-btn" :to="{name: 'PriceCalculationPage', params: {id: quotationData.quotation.id}}">Calculation</router-link>
                        </template>
                        <template v-if="quotationData.quotation.status=='3'">
                            <!--<router-link class="btn custom-btn" :to="{name: 'PriceCalculationPage', params: {id: quotationData.quotation.id}}">Calculation</router-link>-->
                        </template>
                        <template v-if="quotationData.quotation.status=='4'">
                            <a href="javascript:void(0)" class="btn custom-btn" v-on:click="updateQuoteStatus(6)">Order Lost</a>
                            <a href="javascript:void(0)" class="btn custom-btn ml-1" v-on:click="updateQuoteStatus(7)">Order Won</a>
                        </template>
                        <template v-if="quotationData.quotation.status=='5' && isQuoteReady() == true">
                            <router-link class="btn custom-btn" :to="{name: 'SendToCustomerPage', params: {id: quotationData.quotation.id}}">Send to Customer</router-link>
                        </template>
                        <template v-if="quotationData.quotation.status=='6' || quotationData.quotation.status=='7'">
                            <router-link class="btn custom-btn" :to="{name: 'ViewCustomerQuote', params: {id: quotationData.quotation.id}}">Quote Preview</router-link>
                        </template>
                        <template v-if="quotationData.quotation.status=='4' || quotationData.quotation.status=='5' || quotationData.quotation.status=='7'">
                            <a href="javascript:void(0)" class="btn custom-btn ml-1" v-on:click="createSalesOrder">Create Sales Order</a>
                        </template>


                        <template v-if="quotationData.quotation.status !='1'">
                            <div class="float-right">
                                <div class="btn-group">
                                <button class="btn  dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a v-if="isQuoteReady() == true" class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#sendToVendorModal"><i class="fas fa-paper-plane"></i> Send To Vendor</a>
                                    <template v-if="quotationData.quotation.status !='3'">
                                        <router-link class="dropdown-item" :to="{name: 'PriceCalculationPage', params: {id: quotationData.quotation.id}}"><i class="fas fa-calculator"></i> Calculation</router-link>
                                    </template>
                                    <template v-if="(quotationData.quotation.status !='6' || quotationData.quotation.status !='7')">
                                        <router-link class="dropdown-item" :to="{name: 'SendToCustomerPage', params: {id: quotationData.quotation.id}}"><i class="fas fa-user"></i> Send to Customer</router-link>
                                    </template>
                                </div>
                                </div>
                            </div>
                        </template>
                    </div>

                </div>
            </div>


        </div>

        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

        <QuotationNotesModal :quotation="quotationData.quotation" :quote_notes="quotationData.quote_notes"
                             @noteAddedEvent="noteAddedEvent" @noteUpdatedEvent="noteAddedEvent"></QuotationNotesModal>
        <QuotationRemindersModal :quotation="quotationData.quotation" :bus="bus"></QuotationRemindersModal>
        <QuotationHistoryModal :quotation="quotationData.quotation"></QuotationHistoryModal>
        <QuotationMessageModal :quotation="quotationData.quotation" :prevVersionMailData="prevVersionMailData"></QuotationMessageModal>
        <QuotationVendorMailModal :quotation="quotationData.quotation"></QuotationVendorMailModal>
        <SendToVendorModal :quotationData="quotationData" :quotation="quotationData.quotation" @vendorEmailSentEvent="vendorEmailSentEvent"></SendToVendorModal>
        <QuotationAddTaskModal :quotationData="quotationData" :quotation="quotationData.quotation" @taskAddedEvent="taskAddedEvent"></QuotationAddTaskModal>

        <!-- Modal -->
        <div class="modal" id="importModal">
            <form @submit.prevent="importCsv" method="post" class="form form-horizontal" name="frmCSVImport"
                  id="frmCSVImport" enctype="multipart/form-data">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content border-0">
                        <div class="modal-header p-3 bg-soft-info">
                            <h5 class="modal-title" id="importModalLabel">Import Products</h5>
                            <button type="button" class="close btn-close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                        </div>
                        <div class="modal-body">
                            <div>
                                <label for="formFile" class="form-label">File *</label>
                                <input class="form-control" type="file" id="formFile" name="formFile" @change="handleProductImportFileUpload( $event )" accept=".csv">
                            </div>
                            <div class="mt-4">
                                <label for="formFile" class="form-label d-block">Download SCV</label>
                                <a href="/admin/sample.csv" class="btn btn-primary fw-semibold fs-14 px-4">Download Sample.csv</a>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-blue">Import</button>
                        </div>
                    </div>
                </div>
            </form>

        </div>
        <div class="modal fade" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <form @submit.prevent="importCsv" method="post" class="form form-horizontal" name="frmCSVImport"
                  id="frmCSVImport_old" enctype="multipart/form-data">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exportModalLabel">Import Products</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="alert alert-danger error_msg alert-dismissible" style="display: none;">
                                <a href="javascript:void(0)" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                <span class="error_alert" style="color: #fff;"></span>
                            </div>
                            <div class="form-body">
                                <div class="form-group row">
                                    <label class="col-md-3 label-control" for="csv_file">File *</label>
                                    <div class="col-md-9">
                                        <input type="file" name="csv_file" id="csv_file" @change="handleProductImportFileUpload( $event )" accept=".csv"
                                               style="border: none;">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-3 label-control" >Sample CSV</label>
                                    <div class="col-md-9">
                                        <a :href="'/admin/sample.csv'" download>Download Sample.csv</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-blue" id="import_btn">Import</button>
                        </div>


                    </div>
                </div>
            </form>
        </div>

        <div class="modal fade" id="CloneModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-soft-info">
                        <h5 class="modal-title" id="exampleModalLabel">Reason to clone quote</h5>
                    </div>
                    <div class="modal-body">
                        <form id="addCloneReason" name="addCloneReason" method="post">
                            <div id="error_alert_reason" class="alert alert-danger" style="display: none;"></div>
                            <div class="form-group">
                                <label for="reason"></label>
                                <input type="text" name="name" style="height: 45px;" v-model="reason" class="form-control" id="reason" aria-describedby="name" placeholder="Enter reason">
                            </div>

                            <div class="mt-4 text-end">
                                <button type="button"  class="btn btn-danger me-1" data-dismiss="modal">Close</button>
                                <button type="button" id="save_reason_btn" class="btn btn-primary" v-on:click="cloneQuote">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="soCreateConfirmModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-soft-info">
                        <h5 class="modal-title">Confirm SO Create</h5>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive product-create table-card" v-if="salesOrder && salesOrder.orders && salesOrder.orders.data">
                            <table class="table table-custom table-bordered mb-0">
                                <thead>
                                <tr>
                                    <th>SO No.</th>
                                    <th>Created Date</th>
                                </tr>
                                </thead>
                                <tr v-for="(item, index) in salesOrder.orders.data">
                                    <td>
                                        <router-link :to="{ name: 'orderShow', params: { id: item.id }}" target="_blank">#{{ item.order_number }}</router-link>
                                    </td>
                                    <td>{{ formatDate(item.created_at) }}</td>
                                </tr>
                            </table>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-blue" @click="goToCreateSO" data-dismiss="modal">Create another SO</button>
                    </div>
                </div>
            </div>
        </div>
        <LightBox :media="previewMedia" :showLightBox="false" :showThumbs="false" ref="lightbox"></LightBox>
        <CustomerAddModal @customerDataSaved="customerDataSaved($event)"></CustomerAddModal>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {debounce} from 'lodash';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import LightBox from 'vue-it-bigger';
import QuotationNotesModal from "../../components/QuotationNotesModal";
import QuotationRemindersModal from "../../components/QuotationRemindersModal";
import QuotationHistoryModal from "../../components/QuotationHistoryModal";
import QuotationMessageModal from "../../components/QuotationMessageModal";
import QuotationVendorMailModal from "../../components/QuotationVendorMailModal";
import SendToVendorModal from "../../components/SendToVendorModal";
import QuotationAddTaskModal from "../../components/QuotationAddTaskModal";
import CustomerAddModal from "../../components/CustomerAddModal";
import VueCkeditor from 'vue-ckeditor2';

export default {
    name: "QuotationShow",
    components: {
        VueTypeaheadBootstrap,
        vueDropzone: vue2Dropzone,
        LightBox,
        QuotationNotesModal,
        QuotationRemindersModal,
        QuotationHistoryModal,
        QuotationMessageModal,
        QuotationVendorMailModal,
        SendToVendorModal,
        QuotationAddTaskModal,
        CustomerAddModal,
        VueCkeditor
    },
    created() {
        this.getQuotation();
        this.getSettings();
        this.getOrders();
        this.getPurchaseOrders();
    },
    data() {
        return {
            bus: new Vue(),
            quotationData: {
                //smtp_user: null,
                added_by: null,
                //DesktopNotification: null,
                //notify: null,
                admin_user: null,
                quotation: null,
                quote_products: [],
                quote_attachments:[],
                count_products: null,
                sale_rep_name: null,
                quote_notes: null,
                //vendor_mail_list: null,
                customer_contact: null,
                //sale_users: [],
                quote_status: [],
                //countries: [],
                quote_versions: [],
                //quote_reason: null,
                user_type: null,
                role: null,
                user: null
            },
            edit_product_id: null,
            settings: {
                quote_number: null,
                sale_users: [],
                countries: [],
                draft_count: 0,
                max_products: 0,
                max_tiers: 0
            },
            isEditFirstSection: false,
            isEditAddedBySection: false,
            isEditProductSection: false,
            salesOrder: {
                orders: {
                    data: []
                },
                config: null,
                current_page:1,
                per_page:10,
                total:0,
            },
            purchaseOrder: {
                orders: {
                    data: []
                },
                config: null,
                current_page:1,
                per_page:10,
                total:0,
            },
            dropzoneOptions: {
                url: window.route('quote.addAttachments'),
                thumbnailWidth: 150,
                maxFilesize: 204800000, //mb
                maxFiles: 200,//10,
                addRemoveLinks: false,
                chunking: false,
                timeout:0,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            csv_file: null,
            customerForm: {
                customer: null,
                customer_id: null,
                sale_rep: null,
                quote_id: null,
                quote_status_id: null,
                quote_update_number: null,
                reason: null,
            },
            customers: [],
            customerData: null,
            adminForm: {
                admin_user: [],
                quote_id: null
            },
            reason: null,
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products:[],
                selectedProducts: [],
            },
            products: [],
            cloneQuoteData: {
                quotation: null,
                sale_users: [],
                countries: [],
                customer: null,
                customer_contact: null,
                products: [],
            },
            clonedQuotation: {
                parent_quote: null,
                quote_number: null,
                sale_rep: null,
                quote_name: null,
                products: [],
            },
            previewMedia: [],
            attachment_edit_id: null,
            isExpandedView: false,
            newQuotation: {
                parent_quote: null,
                quote_number: null,
                is_draft: null,
                quote_name: null,
                customer_id: null,
                customer: null,
                sale_rep: null,
                files_attached: [],
                notes: [""],
                products: [
                    {
                        product_id: null,
                        product: null,
                        product_num: null,
                        name: null,
                        description: null,
                        quantity_unit: 'bags',
                        is_master_product_modify: false,
                        tiers: [
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            }
                        ],
                    }
                ],

            },
            editorConfigMin: {
                toolbar: [],
                ui: { top: 10, right: 10, bottom: 10, left: 10}
            },
            prevVersionMailData: {
                isPrevMail: false, id: null, customer_id: null, contact_id: null
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setQuotations',
            'setNewOrder',
            'setNewQuotation',
            'setQuotationLoading'
        ]),
        isQuoteReady(){
            if(this.quotationData.quote_products && this.quotationData.quote_products.length > 0){
                let totalTiers = 0;
                this.quotationData.quote_products.forEach((x) => {
                    totalTiers += x.quote_tiers.filter((y) => y.id != null).length;
                });

                if(totalTiers > 0){
                    return true;
                }
            }
            return false;
        },
        tierNumberFormat(index, tierIndex){
            let tier = this.quotationData.quote_products[index].quote_tiers[tierIndex].tier_value.replace(',', '');
            if(!isNaN(tier)) {
                let nfObject = new Intl.NumberFormat('en-US');
                this.quotationData.quote_products[index].quote_tiers[tierIndex].tier_value = nfObject.format(tier);
            }
        },
        openPrevVersionMail(isPrevMail, id, customer_id, contact_id){
            this.prevVersionMailData.isPrevMail = isPrevMail;
            this.prevVersionMailData.id = id;
            this.prevVersionMailData.customer_id = customer_id;
            this.prevVersionMailData.contact_id = contact_id;

            $("#quotationMessageModal").modal('show');
        },
        taskAddedEvent() {
            this.bus.$emit('taskAddedEvent');
            //this.getQuotation();
        },
        goBack() {
            this.$router.push({name: 'quotations'});
        },
        customerDataSaved(customer){
            if (customer) {
                this.customerForm.customer_id = customer.id;
                //this.customerForm.customer = customer;
                let html = '<div>' + customer.company_name + '</div>';
                if(customer.customer_contacts && customer.customer_contacts.length > 0) {
                    html = '<div>' + customer.customer_contacts[0].contact_name + '</div>' + '<div class="short_text">Company:'+ customer.company_name + '</div>';
                }
                this.customerForm.customer = {
                    id: customer.id,
                    sales_rep_id: customer.sales_rep_id,
                    text: '<div>' + customer.company_name + '</div>',
                    name: '<div>' + customer.company_name + '</div>',
                    html: html,
                };
            }
        },
        getFileIconForAttachment(attachment) {
            // ri-folder-zip-line, ri-file-ppt-2-line, bx bxs-file-pdf, bx bxs-file-doc, bx bx-image-alt
            //console.log(attachment.file_name.toLowerCase())
            if(attachment.file_name.toLowerCase().includes(".pdf")) {
                return 'fas fa-file-pdf';
            } else if(attachment.file_name.toLowerCase().includes(".doc")) {
                return 'fas fa-file-word';
            } else if(attachment.file_name.toLowerCase().includes(".docx")) {
                return 'fas fa-file-word';
            } else if(attachment.file_name.toLowerCase().includes(".xlx")) {
                return 'fas fa-file-word';
            } else if(attachment.file_name.toLowerCase().includes(".xlsx")) {
                return 'fas fa-file-word';
            } else if(attachment.file_name.toLowerCase().includes(".ppt")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.file_name.toLowerCase().includes(".pptx")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.file_name.toLowerCase().includes(".zip") || attachment.file_name.toLowerCase().includes(".rar") ||
                attachment.file_name.toLowerCase().includes(".7z") || attachment.file_name.toLowerCase().includes(".gzip") ||
                attachment.file_name.toLowerCase().includes(".gz")) {
                return 'ri-folder-zip-line';
            } else {
                return 'fas fa-file-image';
            }
        },
        imagePreview(src, caption = '') {
            this.previewMedia = [{
                thumb: src,
                src: src,
                caption: caption, // Optional
                //srcset: '...' // Optional for displaying responsive images
            }];
            this.$refs.lightbox.showImage(0)
        },
        vendorEmailSentEvent(){
            //console.log()
            this.getQuotation();
        },
        goToVersion(id) {
            this.getQuotation(id);
            this.$router.push({ name: 'viewQuote', params: { id: id } });
        },
        goToCreateSO(){
            this.newOrder.customer_id = this.quotationData.quotation.customer_id;
            this.newOrder.sales_rep_id = this.quotationData.quotation.sales_rep_id;
            this.newOrder.quotations.push(this.quotationData.quotation.id);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.show', {id: this.newOrder.customer_id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.newOrder.customer = data.data.customer;
                        this.setNewOrder(this.newOrder);
                        this.$router.push({ name: 'selectProducts' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        createSalesOrder(){
            if(this.salesOrder.orders.data.length > 0){
                $("#soCreateConfirmModal").modal('show');
            } else {
                this.goToCreateSO();
            }
        },
        noteAddedEvent(){
          this.getQuotation();
        },
        handleProductImportFileUpload(event ){
            this.csv_file = event.target.files[0];
        },
        sendingEventQuoteAttachments(file, xhr, formData){
            this.setLoading(true);
            formData.append('quote_id', this.quotationData.quotation.id);
        },
        afterUploadFail(file, response) {
            console.log("Fail : ",response);
            this.setSuccessMessage(response.message);
            this.setLoading(false);
            setTimeout(() => {
                this.setSuccessMessage(null);
            }, 5000);
            this.getQuotation();
        },
        afterUploadComplete(file, response) {
            console.log(response);
            this.setSuccessMessage(response.message);
            this.setLoading(false);
            setTimeout(() => {
                this.setSuccessMessage(null);
            }, 5000);
            this.getQuotation();
        },
        download(path, attach) {
           // window.open(attach.file_url, "_blank");
            
            let url = window.route('quotations.downloadFile', {
                id: attach.id,
               // path: 'public/quote_files/',
              //  name: attach.file_name
            });

            //let url = '/quote_files/' + attach.file_name;
            //let url = attach.file_url;
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url,  {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        // Service that handles ajax call
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", attach.file_name);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveProduct(product, index){
            let url = window.route('updateQuoteNewProductData');

            if(product.product_id) {
                url = window.route('updateQuoteProductData');
            }

            let productData = _.cloneDeep(this.quotationData.quote_products[index]);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(url, productData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage('Product data saved successfully!');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.edit_product_id = null;
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

        },
        cancelProductEdit() {
          this.edit_product_id = null;
          this.getQuotation();
        },
        editProduct(product_id){
            this.edit_product_id = product_id;
        },
        addNewTier(index) {
            if(this.settings && this.settings.max_tiers != null &&
                this.quotationData.quote_products[index].quote_tiers.length == this.settings.max_tiers) {
                this.setErrorMessage('Max '+this.settings.max_tiers+' Tiers allowed in Single product');
                setTimeout(() => {
                    this.setErrorMessage(null);
                }, 5000);

                return;
            }
            this.quotationData.quote_products[index].quote_tiers.push({
                id: null,
                tier_value: null,
                sku: null
            });
        },
        removeTier(index, tierIndex, tier, item){
            if(tier.id) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('removeOldTier'), {tier_id: tier.id, product_id: item.product_id }, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            this.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            this.quotationData.quote_products[index].quote_tiers.splice(tierIndex, 1);
                            this.getQuotation();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            } else {
                this.quotationData.quote_products[index].quote_tiers.splice(tierIndex, 1);
            }
        },
        onEditorInput(event, index){

        },
        addProduct(){
            if(this.settings && this.settings.max_products != null &&
                this.quotationData.quote_products.length == this.settings.max_products) {
                this.setErrorMessage('Max '+this.settings.max_products+' Product allowed in Quote');
                setTimeout(() => {
                    this.setErrorMessage(null);
                }, 5000);

                return;
            }
            this.quotationData.quote_products.push({
                id: null,
                product_id: null,
                master_product_id: null,
                master_product: null,
                master_product_num: null,
                quote_id: this.quotationData.quotation.id,
                product_name: null,
                description: null,
                quantity_unit: 'bags',
                quote_tiers: [
                    {
                        tier_value: null,
                        sku: null
                    },
                    {
                        tier_value: null,
                        sku: null
                    },
                    {
                        tier_value: null,
                        sku: null
                    }
                ],
                orders: []
            });
        },
        removeProduct(index, item){
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete product?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.post(window.route('deleteProduct'), {id: item.id, quote_id: self.quotationData.quotation.id }, {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.quotationData.quote_products.splice(index, 1);
                                    self.getQuotation();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });
        },
        updateQuoteName(){
            let self = this;
            self.setLoading(true);
            self.setCommonErrors([]);
            self.setErrorMessage(null);
            return axios.post(window.route('update_quote_name'), {quote_name: self.quotationData.quotation.quote_name, quote_id: self.quotationData.quotation.id }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getQuotation(id = null) {
            let self = this;
            this.setQuotationLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.show', {id: id ? id :this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData = data.data;
                        if(this.quotationData.quote_products){
                            this.quotationData.quote_products.forEach((product, index) => {
                               if(product.quote_tiers.length == 0) {
                                   product.quote_tiers.push({
                                       id: null,
                                       sku: null,
                                       tier_value: null
                                   });
                               } else {
                                   product.quote_tiers.forEach((tier, tierIndex) => {
                                       //this.tierNumberFormat(index, tierIndex);
                                       let tier_value = tier.tier_value.replace(',', '');
                                       if(!isNaN(tier_value)) {
                                           let nfObject = new Intl.NumberFormat('en-US');
                                           tier.tier_value = nfObject.format(tier_value);
                                       }
                                   });
                               }

                            });
                        }
                        this.customerForm.quote_update_number = this.quotationData.quotation.quotation_number;
                        this.customerForm.quote_id = this.quotationData.quotation.id;
                        this.customerForm.customer_id = this.quotationData.quotation.customer_id;

                        if(data.data.quotation.customer_data) {
                            let html = '<div>' + data.data.quotation.customer_data.company_name + '</div>';
                            if(data.data.customer_contact) {
                                html = '<div>' + data.data.customer_contact.contact_name + '</div>' + '<div class="short_text">Company:'+ data.data.quotation.customer_data.company_name + '</div>';
                            }
                            this.customerForm.customer = {
                                id: data.data.quotation.customer_data.id,
                                sales_rep_id: data.data.quotation.customer_data.sales_rep_id,
                                text: '<div>' + data.data.quotation.customer_data.company_name + '</div>',
                                name: '<div>' + data.data.quotation.customer_data.company_name + '</div>',
                                html: html,
                            };
                        }

                        this.customerForm.sale_rep = this.quotationData.quotation.sales_rep_id;
                        this.customerForm.quote_status_id = this.quotationData.quotation.status;

                        this.adminForm.quote_id = this.quotationData.quotation.id;

                        if(this.quotationData.quote_attachments) {
                            this.quotationData.quote_attachments.forEach((x, index) => {
                                if(x.edited_file_name == null) {
                                    x.edited_file_name = x.file_name;
                                }
                            });
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setQuotationLoading(false);

                });
        },
        getOrders() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotes.orders', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.salesOrder.orders = data.data.orders;
                        this.salesOrder.config = data.data.config;
                        this.salesOrder.current_page = data.data.orders.current_page;
                        this.salesOrder.per_page = data.data.orders.per_page;
                        this.salesOrder.total = data.data.orders.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getPurchaseOrders() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotes.purchaseOrders', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.purchaseOrder.orders = data.data.orders;
                        this.purchaseOrder.config = data.data.config;
                        this.purchaseOrder.current_page = data.data.orders.current_page;
                        this.purchaseOrder.per_page = data.data.orders.per_page;
                        this.purchaseOrder.total = data.data.orders.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getVersionTitle(version) {
            if (!version.final_version) {
                return 'Update Final Version';
            } else if (version.final_version) {
                return 'Final Version';
            }
            return '';
        },
        getQuoteTimeByType(type, id, time) {
            //quotationData.quote_time['new'][item.id]['created']
            if (this.quotationData.quote_time &&
                this.quotationData.quote_time[type] &&
                this.quotationData.quote_time[type][id] &&
                this.quotationData.quote_time[type][id][time]) {
                return this.quotationData.quote_time[type][id][time];
            }
            return '';
        },
        deleteQuoteFile(file_name, id, index) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quote.deleteAttachments'), {id: id, file_name: file_name }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.quotationData.quote_attachments.splice(index, 1);
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        renameQuoteFile(file_name, id, index) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quote.renameAttachment'), {id: id, edited_file_name: file_name }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.attachment_edit_id = null;
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        importCsv() {
            let formData = new FormData();
            formData.append('csv_file', this.csv_file);
            formData.append('quote_id', this.quotationData.quotation.id);

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quotations.importCsv'), formData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        $('#importModal').modal('hide');
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        updateQuoteStatus(status) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('updateQuoteStatus'), {quote_update_status: status, quote_update_id: this.quotationData.quotation.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.settings'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.settings = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveCustomerData(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('updateQuoteCustomerData'), this.customerForm, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage("Quote data saved successfully");
                        this.isEditFirstSection = false;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getCustomerDetail(customer_id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchCustomerDetails'), {customer_id: customer_id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.customerData = data.data.customer_data;
                        if(data.data.customer_data.sales_rep_id) {
                            this.customerForm.sale_rep = data.data.customer_data.sales_rep_id;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        onCustomerSelect(event){
            if (event) {
                this.customerForm.customer_id = event.id;
            } else {
                this.customerForm.customer_id = null;
            }
        },
        onCustomerDeSelect(event){
            this.customerForm.customer_id = null;
        },
        onCustomerSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        onProductSelect(event, index){
            if(event != null) {
                this.quotationData.quote_products[index].master_product_id = event.id;
                this.quotationData.quote_products[index].master_product_num = event.product_num;
                //let product = this.products.find((x) => x.id == event.id);
                if(this.quotationData.quote_products[index].product_name == null) {
                    this.quotationData.quote_products[index].product_name = event.product_name;
                }
                if(this.quotationData.quote_products[index].description == null) {
                    this.quotationData.quote_products[index].description = event.product_desc;
                }
            } else {
                this.quotationData.quote_products[index].master_product_id = null;
                this.quotationData.quote_products[index].master_product_num = null;
            }
            // this.setNewQuotation(this.form);
        },
        onProductDeSelect(event){
            //console.log(event)
            // this.setNewQuotation(this.form);
        },
        onProductSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchProductNew(loading, search, this);
            }
        },
        searchProductNew: _.debounce((loading, search, vm) => {
            return axios.get(window.route('so.products.search', {
                page: 1,
                exclude_products: [],
                search_filter: search,
                status_filter: null}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.products = data.data.products.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        saveAdminData(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('updateAdminUserData'), this.adminForm, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage("Quote data saved successfully");
                        this.isEditAddedBySection = false;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getQuotation();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteVersionModal(deleteVersionId){
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.delete(window.route('deleteQuoteVersion', {id: deleteVersionId}),  {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.getQuotation();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });
        },
        updateVersionModal(deleteVersionId){
            let self = this;
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Do you really want to finalize these version?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios.put(window.route('updateQuoteFinalVersion', {id: deleteVersionId}),  {
                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(data.data);
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                    self.getQuotation();
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }

                }
            });
        },
        cloneQuote(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('saveCloneQuoteReason'), {reason: this.reason, quote_id: this.quotationData.quotation.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.getCloneQuote();
                        this.setSuccessMessage(data.data);
                        $('#CloneModal').modal('hide');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveCloneQuote() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('saveCloneQuote'), this.clonedQuotation, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.getQuotation(data.id);
                        this.clonedQuotation = {
                            parent_quote: null,
                            quote_number: null,
                            sale_rep: null,
                            quote_name: null,
                            products: [],
                        };

                        this.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            if(data.id ) {
                                this.$router.push({ name: 'viewQuote', params: { id: data.id } });
                            }
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getCloneQuote() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('cloneQuote', {id: this.quotationData.quotation.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.cloneQuoteData = data.data;
                        /*
                        this.clonedQuotation.parent_quote = this.quotationData.quotation.id;
                        this.clonedQuotation.quote_number = this.cloneQuoteData.quotation.quotation_number;
                        if(this.cloneQuoteData.quotation.quote_name) {
                            this.clonedQuotation.quote_name = this.cloneQuoteData.quotation.quote_name;
                        }
                        if(this.cloneQuoteData.quotation.sales_rep_id) {
                            this.clonedQuotation.sale_rep = this.cloneQuoteData.quotation.sales_rep_id;
                        }
                        this.clonedQuotation.products = this.cloneQuoteData.products;
                        this.saveCloneQuote();
                         */

                        this.newQuotation.parent_quote =  this.quotationData.quotation.id;
                        this.newQuotation.quote_number = this.cloneQuoteData.quotation.quotation_number;
                        if(this.cloneQuoteData.quotation.quote_name) {
                            this.newQuotation.quote_name = this.cloneQuoteData.quotation.quote_name;
                        }
                        if(this.cloneQuoteData.quotation.sales_rep_id) {
                            this.newQuotation.sale_rep = this.cloneQuoteData.quotation.sales_rep_id;
                        }

                        if(this.cloneQuoteData.customer) {
                            this.newQuotation.customer_id = this.cloneQuoteData.quotation.customer_id;

                            if(this.cloneQuoteData.customer_contact) {
                                this.newQuotation.customer = {
                                    id: this.cloneQuoteData.quotation.customer_id + '_' + this.cloneQuoteData.customer_contact.id,
                                    sales_rep_id: this.cloneQuoteData.customer.sales_rep ? this.cloneQuoteData.customer.sales_rep.id : null,
                                    text: `<div>${this.cloneQuoteData.customer_contact.contact_name}</div>`,
                                    name: `<div>${this.cloneQuoteData.customer_contact.contact_name}</div>`,
                                    html: `<div>${this.cloneQuoteData.customer_contact.contact_name}</div><div class="short_text">Company:${this.cloneQuoteData.customer.company_name}</div>`,
                                }
                            } else {
                                this.newQuotation.customer = {
                                    id: this.cloneQuoteData.quotation.customer_id,
                                    sales_rep_id: this.cloneQuoteData.customer.sales_rep ? this.cloneQuoteData.customer.sales_rep.id : null,
                                    text: `<div>${this.cloneQuoteData.customer.company_name}</div>`,
                                    name: `<div>${this.cloneQuoteData.customer.company_name}</div>`,
                                    html: `<div>${this.cloneQuoteData.customer.company_name}</div>`,
                                }
                            }

                        }

                        this.newQuotation.products = [];
                        this.cloneQuoteData.products.forEach((x) => {
                            let tiers = [];
                            if (x.quote_tiers) {
                                x.quote_tiers.forEach((tier) => {
                                    tiers.push({tier: tier.tier_value, sku: tier.sku});
                                });
                            }

                            this.newQuotation.products.push({
                                product_id: x.master_product_id,
                                product: _.cloneDeep(x.master_product),
                                product_num: x.master_product_num,
                                name: x.product_name,
                                description: x.description,
                                quantity_unit: x.quantity_unit ? x.quantity_unit : 'bags',
                                is_master_product_modify: false,
                                tiers: tiers,
                            });
                        });
                        this.setNewQuotation(this.newQuotation);
                        setTimeout(() => {
                            this.$router.push({name: 'addQuotePage'});
                        }, 100);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    watch: {
        'customerForm.customer_id': {
            handler: function (after, before) {
                if(after) {
                    this.getCustomerDetail(after);
                }
            },
            deep: true,
        },
    }
}
</script>



<style scoped>

</style>
